import React, { lazy, Suspense } from 'react'
import Loader from 'view/component/loader'

const SuspenseComponent = (props, LazyComponent) => {
  return (<Suspense fallback={<Loader />}>
    <LazyComponent {...props} />
  </Suspense>)
}

export default (importFunc) => {
  const LazyComponent = lazy(importFunc)

  return (props) => SuspenseComponent(props, LazyComponent)
}
